'use client';

import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

const SKILLS = [
  "Kubernetes", "Docker", "Python", "Machine Learning", 
  "Hadoop", "Dask", "Agile", "Next.js", "TypeScript", 
  "PostgreSQL", "Prisma", "TailwindCSS", "AWS", "CI/CD",
  "React", "Node.js", "Git", "Scrum"
];

export default function SkillCloud3D() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="relative h-[500px] w-full flex items-center justify-center overflow-hidden perspective-1000">
      {/* Central Core Glow */}
      <div className="absolute w-32 h-32 bg-indigo-500/20 blur-[80px] rounded-full animate-pulse" />

      <motion.div
        animate={{
          rotateY: isHovered ? 0 : 360,
          rotateX: isHovered ? 0 : 15,
        }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: "linear",
        }}
        onHoverStart={() => setIsHovered(true)}
        onHoverEnd={() => setIsHovered(false)}
        className="relative w-full h-full flex items-center justify-center preserve-3d"
      >
        {SKILLS.map((skill, i) => (
          <SkillItem key={skill} index={i} total={SKILLS.length} label={skill} />
        ))}
      </motion.div>
    </div>
  );
}

function SkillItem({ index, total, label }: { index: number; total: number; label: string }) {
  // Calculate spherical coordinates
  const phi = Math.acos(-1 + (2 * index) / total);
  const theta = Math.sqrt(total * Math.PI) * phi;
  
  const x = 220 * Math.cos(theta) * Math.sin(phi);
  const y = 220 * Math.sin(theta) * Math.sin(phi);
  const z = 220 * Math.cos(phi);

  return (
    <motion.div
      style={{
        position: 'absolute',
        transform: `translate3d(${x}px, ${y}px, ${z}px)`,
      }}
      className="backface-hidden"
    >
      <div className="px-4 py-2 bg-white/5 dark:bg-zinc-900/50 backdrop-blur-md border border-zinc-200 dark:border-zinc-800 rounded-lg shadow-xl shadow-black/5 hover:border-indigo-500 hover:text-indigo-500 transition-all cursor-default">
        <span className="text-[10px] font-black uppercase tracking-widest whitespace-nowrap">
          {label}
        </span>
      </div>
    </motion.div>
  );
}